import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import Button from '@welldev-group/rcl-button';
import IconButton from '@welldev-group/rcl-icon-button';
import { Avatar, I18nText } from '@welldev-group/react-comp-lib';

import SanitizedHTML from '../../../shared/components/SanitizedHTML';
import httpClient from '../../../shared/libraries/httpClient';
import routes from '../../../shared/routes';

const DraftMessage = props => {
  const {
    message,
    selectedSupportTicketId,
    fetchTickets,
    fetchMessages,
    setMessageToEdit,
    setMessageToEditId,
    setUncommittedMessage,
  } = props;

  const params = {
    support_ticket_message: {
      body: message.body,
    },
  };

  const { avatar, firstName, lastName, name } = message.user;

  const editMessage = () => {
    setMessageToEdit(message.body);
    setMessageToEditId(message.id);
  };

  const deleteMessage = async () => {
    const { data } = await httpClient.delete(
      routes.support.message.delete({
        support_ticket_id: selectedSupportTicketId,
        id: message.id,
      }),
    );

    if (data.error === null) {
      fetchMessages().then(() => {
        setUncommittedMessage('');
      });
    }
  };

  const scheduleMessage = async () => {
    const { data } = await httpClient.put(
      routes.support.message.schedule({
        support_ticket_id: selectedSupportTicketId,
        id: message.id,
      }),
      params,
    );

    if (data.error === null) {
      fetchMessages().then(() => {
        setUncommittedMessage('');
      });
      fetchTickets();
    }
  };

  return (
    <div className="support-draft-message">
      <div className="support-draft-message__user-info">
        <Avatar
          src={avatar}
          firstName={firstName}
          lastName={lastName}
          size="tiny"
        />
        <span>{name}</span>
      </div>
      <div className="support-draft-message__message">
        <I18nText id="support.draft_title_html" />
        <SanitizedHTML html={message.body} />
        <div className="support-draft-message__actions">
          <div className="support-draft-message__actions">
            <IconButton
              onClick={editMessage}
              isIconOnly={true}
              icon={<Icon name="edit" />}
              size="tiny"
            />
            <IconButton
              onClick={deleteMessage}
              isIconOnly={true}
              icon={<Icon name="delete" />}
              size="tiny"
            />
          </div>
          <Button
            onClick={scheduleMessage}
            label={<I18nText id="support.send" />}
            version="v2"
            size="tiny"
            type="primary"
          />
        </div>
      </div>
    </div>
  );
};

DraftMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    body: PropTypes.string.isRequired,
    user: PropTypes.shape({
      avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      id: PropTypes.number.isRequired,
      loggedIn: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  selectedSupportTicketId: PropTypes.number.isRequired,
  fetchTickets: PropTypes.func.isRequired,
  fetchMessages: PropTypes.func.isRequired,
  setMessageToEdit: PropTypes.func.isRequired,
  setMessageToEditId: PropTypes.func.isRequired,
  setUncommittedMessage: PropTypes.func.isRequired,
};

export default DraftMessage;
